// Simple mock user store backed by localStorage for demo purposes
// Not for production use

const USERS_KEY = 'users';
const CURRENT_USER_KEY = 'currentUser';

export function getUsers() {
  try {
    const raw = localStorage.getItem(USERS_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function saveUsers(users) {
  localStorage.setItem(USERS_KEY, JSON.stringify(users || []));
}

export function addUser(user) {
  const users = getUsers();
  const exists = users.some((u) => u.email.toLowerCase() === user.email.toLowerCase());
  if (exists) {
    throw new Error('Email đã được đăng ký');
  }
  const toSave = {
    id: Date.now(),
    name: user.name || '',
    email: user.email,
    password: user.password, // For demo only
    dueDate: user.dueDate || '',
    currentWeek: user.currentWeek || '',
    avatar: user.avatar || '',
    posts: typeof user.posts === 'number' ? user.posts : 0,
    comments: typeof user.comments === 'number' ? user.comments : 0,
  };
  users.push(toSave);
  saveUsers(users);
  return toSave;
}

export function findUserByEmail(email) {
  return getUsers().find((u) => u.email.toLowerCase() === email.toLowerCase());
}

export function verifyCredentials(email, password) {
  const user = findUserByEmail(email);
  if (!user) return { ok: false, user: null };
  if (user.password !== password) return { ok: false, user: null };
  return { ok: true, user };
}

export function setCurrentUser(user) {
  localStorage.setItem(CURRENT_USER_KEY, JSON.stringify(user));
}

export function getCurrentUser() {
  try {
    const raw = localStorage.getItem(CURRENT_USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearCurrentUser() {
  localStorage.removeItem(CURRENT_USER_KEY);
}


